"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { NavCollapseIcon, NavOpenIcon } from "@/layouts/app-shell/navigation/navigation-icons";
import { SidebarGroup, SidebarMenu, SidebarMenuButton, SidebarMenuItem, useSidebarLayout } from "@/layouts/app-shell/sidebar-layout";
import { cn } from "@/lib/utils";
import type { SidebarNavGroup } from "@/types/sidebar";
import { NavigationIcon, NavigationItem } from "./navigation-item";
import itemClasses from "./navigation-item.module.css";
import classes from "./navigation-section.module.css";
interface NavigationSectionProps {
  group: SidebarNavGroup;
  onClose?: () => void;
  forceExpanded?: boolean;
  prependToggle?: boolean;
}
function SidebarToggleItem() {
  const $ = _c(12);
  const {
    open,
    toggleSidebar,
    showCollapsedVisual
  } = useSidebarLayout();
  const label = open ? "Close" : "Open";
  const t0 = showCollapsedVisual && classes.toggleButtonCollapsed;
  let t1;
  if ($[0] !== t0) {
    t1 = cn(classes.toggleButton, t0);
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = open ? NavCollapseIcon : NavOpenIcon;
  let t3;
  if ($[2] !== t2) {
    t3 = <NavigationIcon icon={t2} state="default" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== label) {
    t4 = <span className={classes.toggleLabel}>{label}</span>;
    $[4] = label;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== label || $[7] !== t1 || $[8] !== t3 || $[9] !== t4 || $[10] !== toggleSidebar) {
    t5 = <SidebarMenuItem><SidebarMenuButton tooltip={label} onClick={toggleSidebar} className={t1}>{t3}{t4}</SidebarMenuButton></SidebarMenuItem>;
    $[6] = label;
    $[7] = t1;
    $[8] = t3;
    $[9] = t4;
    $[10] = toggleSidebar;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
export function NavigationSection(t0) {
  const $ = _c(21);
  const {
    group,
    onClose,
    forceExpanded,
    prependToggle
  } = t0;
  const pathname = usePathname();
  const {
    showCollapsedVisual
  } = useSidebarLayout();
  const showCollapsed = forceExpanded ? false : showCollapsedVisual;
  let t1;
  if ($[0] !== pathname) {
    t1 = url => {
      if (url === "#") {
        return false;
      }
      if (url === pathname) {
        return true;
      }
      return pathname.startsWith(url) && url !== "/";
    };
    $[0] = pathname;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const isActiveUrl = t1;
  let t2;
  if ($[2] !== group.dividerBefore) {
    t2 = group.dividerBefore && <div className={classes.divider} role="separator" aria-hidden="true" />;
    $[2] = group.dividerBefore;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== prependToggle) {
    t3 = prependToggle && <SidebarToggleItem />;
    $[4] = prependToggle;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== group.items || $[7] !== isActiveUrl || $[8] !== onClose || $[9] !== showCollapsed) {
    let t5;
    if ($[11] !== isActiveUrl || $[12] !== onClose || $[13] !== showCollapsed) {
      t5 = item => {
        const isItemActive = isActiveUrl(item.url);
        return <SidebarMenuItem key={item.title}><SidebarMenuButton tooltip={item.title} isActive={isItemActive} className={itemClasses.menuButton} asChild={true}>{item.icon ? <NavigationItem icon={item.icon} label={item.title} href={item.url} isActive={isItemActive} isCollapsed={showCollapsed} onClick={onClose} /> : <Link href={item.url} onClick={onClose}><span>{item.title}</span></Link>}</SidebarMenuButton></SidebarMenuItem>;
      };
      $[11] = isActiveUrl;
      $[12] = onClose;
      $[13] = showCollapsed;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    t4 = group.items.map(t5);
    $[6] = group.items;
    $[7] = isActiveUrl;
    $[8] = onClose;
    $[9] = showCollapsed;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[15] !== t3 || $[16] !== t4) {
    t5 = <SidebarMenu>{t3}{t4}</SidebarMenu>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== t2 || $[19] !== t5) {
    t6 = <SidebarGroup className={classes.group}>{t2}{t5}</SidebarGroup>;
    $[18] = t2;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
}